(() => {
  if (window.RatnivaCartStateSync) return;
  window.RatnivaCartStateSync = true;

  let latestSyncId = 0;

  const parseSection = (html, selector) => {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const getCartStateUrl = () => {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const requestUrl = new URL(`${rootUrl}cart.js`, window.location.origin);
    requestUrl.searchParams.set('_', Date.now().toString());
    return requestUrl;
  };

  const getCartDrawerUrl = () => {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const requestUrl = new URL(rootUrl, window.location.origin);
    requestUrl.searchParams.set('sections', 'cart-drawer');
    requestUrl.searchParams.set('sections_url', window.location.pathname);
    requestUrl.searchParams.set('_', Date.now().toString());
    return requestUrl;
  };

  const fetchJson = async (url) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) throw new Error(`Cart sync failed with status ${response.status}`);
    return response.json();
  };

  const renderCartCount = (itemCount) => {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const currentBubble = cartLink.querySelector('.cart-count-bubble');

    if (itemCount <= 0) {
      currentBubble?.remove();
      return;
    }

    const bubble = currentBubble || document.createElement('div');
    bubble.className = 'cart-count-bubble';
    bubble.replaceChildren();

    if (itemCount < 100) {
      const count = document.createElement('span');
      count.setAttribute('aria-hidden', 'true');
      count.textContent = itemCount.toString();
      bubble.appendChild(count);
    }

    if (!currentBubble) cartLink.appendChild(bubble);
  };

  const syncCartSections = async () => {
    const syncId = ++latestSyncId;
    const currentDrawer = document.querySelector('cart-drawer');
    const cartStateRequest = fetchJson(getCartStateUrl());
    const drawerRequest = currentDrawer
      ? fetchJson(getCartDrawerUrl()).catch((error) => {
          console.error(error);
          return null;
        })
      : Promise.resolve(null);
    const [cartState, sections] = await Promise.all([cartStateRequest, drawerRequest]);

    if (syncId !== latestSyncId) return;

    renderCartCount(cartState.item_count);

    if (!currentDrawer || !sections) return;

    const nextDrawer = parseSection(sections['cart-drawer'], 'cart-drawer');
    const currentDrawerInner = currentDrawer.querySelector('#CartDrawer > .drawer__inner');
    const nextDrawerInner = nextDrawer?.querySelector('#CartDrawer > .drawer__inner');

    if (!nextDrawer || !currentDrawerInner || !nextDrawerInner) return;

    currentDrawer.classList.toggle('is-empty', nextDrawer.classList.contains('is-empty'));
    currentDrawerInner.replaceChildren(...nextDrawerInner.cloneNode(true).childNodes);
  };

  const scheduleCartSync = () => {
    syncCartSections().catch((error) => console.error(error));
    window.setTimeout(() => syncCartSections().catch((error) => console.error(error)), 400);
  };

  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!event.persisted && navigation?.type !== 'back_forward') return;

    scheduleCartSync();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;

    const navigation = performance.getEntriesByType('navigation')[0];
    if (navigation?.type !== 'back_forward') return;

    syncCartSections().catch((error) => console.error(error));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      latestSyncId += 1;
    });
  }
})();
